import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { useToasts } from '../../../contexts/toasts';
import { Alert, Card, Col, Container, Row } from 'react-bootstrap';
import AppSearch from '../../../components/common/AppSearch';
import { debounce } from 'lodash';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { solid } from '@fortawesome/fontawesome-svg-core/import.macro';
import { TailSpin } from 'react-loader-spinner';
import { Llm } from '../../../api/Llm';


export default function ModelsList() {
  const [models, setModels] = useState<any[]>();
  const [searchText, setSearchText] = useState('');

  const { showToast } = useToasts();

  const filteredModels = useMemo(() => models?.filter(m => m.name.toLowerCase().includes(searchText.toLowerCase())), [models, searchText]);

  const initModels = useCallback(() => {
    Llm.getModels()
      .then(
        ({ data }) => setModels(data.models),
        (err) => {
          setModels([]);
          const message = err.response?.data?.message || err.message;
          const status = err.response?.status;
          showToast('models-error', message, `Models Error ${status ? `(${status})` : ''}`, 'danger');
        });
  }, [showToast]);

  useEffect(() => initModels(), [initModels]);

  const handleSearchChange = useCallback((evt: React.ChangeEvent<HTMLInputElement>) => {
    setSearchText(evt.target.value);
  }, []);

  const debounceSearchChange = useMemo(() => debounce(handleSearchChange, 500), [handleSearchChange]);

  const renderModels = useCallback(() => {
    return (
      <Row>
        {filteredModels?.map((model, index) => (
          <Col key={model.type} md={3} className="px-2">
            <Card className="shadow-sm mb-3">
              <Card.Body className="py-2">
                <Card.Title className="mb-1">{model.name}</Card.Title>
                <p className="text-secondary mb-2">{model.details?.family}</p>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>
    )
  }, [filteredModels]);

  const renderAsyncContent = useCallback(() => {
    if (!filteredModels) return (
      <div className="d-flex justify-content-center py-5 my-5">
        <TailSpin
          height={100}
          width={100}
          color="#677ab1"
          radius="1"
        />
      </div>
    )

    return filteredModels.length === 0
      ? (
        <Alert className="py-2" variant="info">
          <FontAwesomeIcon icon={solid('info-circle')} />
          <span className="ms-2">No models found.</span>
        </Alert>
      )
      : renderModels();
  }, [filteredModels, renderModels]);

  return (
    <Container className="px-0" fluid>
      <Row className="mb-2 align-items-center">
        <Col>
          <h4 className="mb-0">Models List</h4>
        </Col>

        <Col>
          <AppSearch placeholder="Search models..." onChange={debounceSearchChange} />
        </Col>

        <Col xs={6} md={4} className="text-end"></Col>
      </Row>

      {renderAsyncContent()}
    </Container>
  )
}